import React from 'react';
import classes from './ExploreSearchResultTitle..module.scss';
import BackButton from '@core/components/backbutton/BackButton';

const ExploreSearchResultTitle = ({ searchKeyword, resultCount }) => {
    return (
        <div className={`${classes.wrapper} container mb-3`}>
            <div className='d-flex align-items-center gap-2 mb-2'>
                <BackButton type={'bordered'} className={''} />
                <h2>All result for "{searchKeyword}"</h2>
            </div>
            <span>
                {resultCount} results found
            </span>
        </div>
    );
};

export default ExploreSearchResultTitle;